import React, {useEffect} from 'react';
import {Tab, Tabs, Tooltip} from '@mui/material';
import {Vendor} from 'pwm-shared/src/types';
import {formatDate} from 'src/PWM/utils/date-utils';
import {downloadFile} from 'src/PWM/utils/download-file';
import {useVendorApi} from '../vendor.api';
import {PWMWarningIcon} from 'src/PWM/components/PWMIcons';
import {createBlobFromBase64, stripFSChars} from 'src/PWM/utils/string-utils';
import PDFViewer from 'src/PWM/components/PDFViewer';
import {PWMPropertyList, PWMPropertyListItem} from 'src/PWM/components/PWMPropertyList';
import {TableUtils} from 'src/PWM/utils/table-utils';
import {parseInt} from 'lodash';

const {descendingComparator} = new TableUtils();

const Validations: React.FC<IPWMValidationsProps> = (props) => {
  const validations = props.data || [];
  const vendorApi = useVendorApi();
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const [fileUrl, setFileUrl] = React.useState<string>('');
  const [contentUrl, setContentUrl] = React.useState<string>('');
  const [fileName, setFileName] = React.useState<string>('');
  const [pdfMessage, setPdfMessage] = React.useState<string>('');
  const [verificationLog, setVerificationLog] = React.useState<Vendor.ILogData[]>([]);

  const [selectedYear, setSelectedYear] = React.useState<string | number | undefined>();
  const [years, setYears] = React.useState<string[]>();
  const [validationGroups, setValidationGroups] = React.useState<{ [year: string]: Vendor.GetVendorValidations[] }>({});
  const [validationGroup, setValidationGroup] = React.useState<Vendor.GetVendorValidations[]>([]);


  useEffect(() => {
    // group validations by year
    if (validations) {
      const groupedValidations = validations.reduce<{
        [year: string]: Vendor.GetVendorValidations[]
      }>((acc, validation) => {
        const year = new Date(validation.created).getFullYear();
        acc[`${year}`] = acc[`${year}`] || [];
        acc[`${year}`].push(validation);
        return acc;
      }, {});

      // select largest year @ts-ignore
      const yearKeys = Object.keys(groupedValidations);
      const largestYear = yearKeys.reduce((a, b) => parseInt(b) > parseInt(a) ? b : a, '');
      setValidationGroups(groupedValidations);
      setSelectedYear(largestYear as string);
      setYears(yearKeys);
    }
  }, [validations]);
  useEffect(() => {
    setValidationGroup(validationGroups[`${selectedYear}`] as Vendor.GetVendorValidations[]);
  }, [selectedYear]);
  const removeFileUrl = () => window.URL.revokeObjectURL(fileUrl);

  useEffect(() => removeFileUrl, []);

  const openRecord = async (id: number, date: string | Date, message: string = '') => {
    if(!vendorApi) return;
    try {
      props.setBusy(true);
      const {content, contentUrl, log = []} = await vendorApi.getVendorValidationPDF(id);
      const fileName = stripFSChars(`${props.vendorName}-${props.sys.toUpperCase()}-${date}.pdf`);
      downloadFile(contentUrl!, fileName);
      /*setFileUrl(createBlobFromBase64(content!));
      setContentUrl(contentUrl || '');
      setPdfMessage(message);
      setFileName(stripFSChars(`${props.vendorName}-${props.sys.toUpperCase()}-${date}.pdf`));
      setVerificationLog(log);
      setModalOpen(true);*/
    } catch (err) {
      console.error(err);
    } finally {
      props.setBusy(false);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    removeFileUrl();
    setPdfMessage('');
    setFileName('');
  };
  const onSelectYear = (e: any, value: string | number) => setSelectedYear(value);

  return (
    <>
      {years && years.length >= 1 && (
        <Tabs
          value={selectedYear}
          variant="scrollable"
          scrollButtons="auto"
          onChange={onSelectYear}
          sx={{pb: 1}}
        >
          {years.sort().reverse().map((year) => <Tab label={year} key={year} value={year} />)}
        </Tabs>
      )}
      <PWMPropertyList>
        {validationGroup?.sort((a, b) => descendingComparator(a, b, 'created')).map((
          {
            id,
            created,
            success,
            message,
            type
          }) => (
          <PWMPropertyListItem
            key={id}
            align="horizontal"
            label={<Tooltip title={type}><span>{formatDate(created)}</span></Tooltip>}
            sx={{textDecoration: 'underline', cursor: 'pointer'}}
            onClick={() => openRecord(id, created, message)}
          >
            {!success ?
            <Tooltip title={message}><PWMWarningIcon htmlColor="red" /></Tooltip> : null}
          </PWMPropertyListItem>))}
      </PWMPropertyList>
      {fileUrl && <PDFViewer
        message={pdfMessage}
        fileUrl={fileUrl}
        contentUrl={contentUrl}
        fileName={fileName}
        onClose={closeModal}
        isOpen={modalOpen}
        log={verificationLog}
      />}
    </>
  );
};

export default Validations;

interface IPWMValidationsProps {
  children?: React.ReactNode;
  setBusy(isBusy: boolean): any;
  data: Vendor.GetVendorValidations[];
  vendorName: string;
  sys: string;
}

interface IValidationRowProps {
  open(id: number, date: string, message?: string): any;
  id: number;
  success: boolean;
  date: string;
  message?: string;
}